<div class="left-modal">
  @if (loading) {
    <div class="loader"></div>
  }
  <div class="close" (click)="close()"></div>
  @if (!loading) {
    <div class="modal-container">
      @if (position == 'home') {
        @if (!duplicate) {
          <h1>{{(scene ? 'Edit scene' : 'Create scene') | translate}}
            <a (click)="changePosition('copy')">{{'Copy data from scene' | translate}}</a></h1>
          }
          @if (duplicate) {
            <h1>{{'Duplicate scene' | translate}} {{scene.chapter_number}} / {{scene.scene_number}}</h1>
          }
          @if (responseError) {
            <div class="errorMessage">{{responseError | translate}}</div>
          }
          <form #form="ngForm" (ngSubmit)="submitForm(form)" novalidate>
            <div class="row">
              <div class="L-4 M-4 S-6 columns">
                <label>{{'Type' | translate}}**</label>
                <app-dropdown
                  [(appModel)]="formData.scene_type"
                  (appModelChange)="restartProtectionType()"
                  [list]="viewData.scene_types"
                  [value]="'id'"
                  [name]="'name'"
                  [backTranslate]="true"
                  [required]="true"
                ></app-dropdown>
              </div>
              @if (formData.scene_type == 2) {
                <div class="L-4 M-4 S-6 columns">
                  <label>{{'Protection type' | translate}}**</label>
                  <app-dropdown
                    [(appModel)]="formData.scene_protection_type_id"
                    [list]="viewData.scene_protection_types"
                    [value]="'id'"
                    [name]="'name'"
                    [backTranslate]="true"
                    [required]="true"
                  ></app-dropdown>
                </div>
              }
            </div>
            @if (proyect_type_id != 2) {
              <div class="L-4 M-4 S-6 columns">
                <label>{{'Chapter' | translate}}**</label>
                <app-dropdown
                  [(appModel)]="formData.chapter_id"
                  [list]="viewData.chapters"
                  [value]="'id'"
                  [name]="'number'"
                  [backTranslate]="false"
                  [required]="true"
                ></app-dropdown>
              </div>
            }
            <div class="L-4 M-4 S-6 columns">
              <label>{{'Scene number' | translate}}**</label>
              <input class="centered" type="text" name="scene_number" [(ngModel)]="formData.scene_number" placeholder="{{'Insert number' | translate}}" [required]="true">
            </div>
            <div class="L-4 M-4 S-6 columns">
              <label>{{'Day history' | translate}}**</label>
              <input class="centered" type="text" name="day_history" [(ngModel)]="formData.day_history" placeholder="{{'Insert day' | translate}}" [pattern]="_gS.regex.dayHistory" [pattern]="_gS.regex.dayHistory" maxlength="4" [required]="true">
            </div>
            <div class="L-3 M-3 S-6 columns">
              <label>{{'Year' | translate}}</label>
              <input class="centered" type="text" name="year" [(ngModel)]="formData.year" placeholder="{{'Insert number' | translate}}" [pattern]="_gS.regex.year" maxlength="4">
            </div>
            <div class="L-3 M-3 S-6 columns">
              <label>{{'Page' | translate}}**</label>
              <input class="centered" type="text" name="page" [(ngModel)]="formData.page" placeholder="{{'Insert number' | translate}}" [pattern]="_gS.regex.page" maxlength="3" [required]="true">
            </div>
            <div class="L-3 M-3 S-6 columns">
              <label>{{'Pages' | translate}}**</label>
              <app-page-input  name= "pages" [(appModel)]="formData.pages" [required]="true"></app-page-input>
              <!-- <input class="centered" type="text" name="pages" [(ngModel)]="formData.pages" placeholder="{{'Insert number' | translate}}" required> -->
            </div>
            @if (formData.scene_type== 1 || formData.scene_protection_type_id == 1) {
              <div class="L-3 M-3 S-6 columns">
                <label>{{'Projected_abb' | translate}}</label>
                <app-minutes-input name="minutes" [(appModel)]="formData.projected_minutes"></app-minutes-input>
              </div>
            }
            <div class="L-4 M-4 S-6 columns">
              <label>{{'Location / studio' | translate}}**</label>
              <app-dropdown
                [(appModel)]="formData.location_studio_option_id"
                [list]="viewData.scene_loc_std_options"
                [value]="'id'"
                [name]="'name'"
                [backTranslate]="true"
                [required]="true"
              ></app-dropdown>
            </div>
            <div class="L-4 M-4 S-6 columns">
              <label>{{'interior / exterior' | translate}}**</label>
              <app-dropdown
                [(appModel)]="formData.interior_exterior_option_id"
                [list]="viewData.scene_interior_exterior_options"
                [value]="'id'"
                [name]="'name'"
                [backTranslate]="true"
                [required]="true"
              ></app-dropdown>
            </div>
            <div class="L-4 M-4 S-6 columns">
              <label>{{'Day / night' | translate}}**</label>
              <app-new-dropdown
                [(ngModel)]="formData.day_night_option_id"
                [list]="viewData.scene_day_night_options"
                [valueId]="'id'"
                [nameLabel]="'name'"
                [backTranslate]="true"
                [toCreate]="true"
                [required]="true"
                name="day_night_option_id"
              ></app-new-dropdown>
            </div>
            <div class="L-6 M-6 S-12 columns">
              <label>{{'Location' | translate}}@if (formData.scene_type == 1) {
                <span>**</span>
              }</label>
              <app-dropdown
                [(appModel)]="formData.location_id"
                (appModelChange)="filterSets()"
                [list]="viewData.locations"
                [value]="'id'"
                [debug]="true"
                [name]="'location_name'"
                [toCreate]="true"
                [(createValue)]="formData.location_name"
                [uppercase]="true"
                [required]="true"
              ></app-dropdown>
            </div>
            <div class="L-6 M-6 S-12 columns">
              <label>{{'Set' | translate}}@if (formData.scene_type == 1) {
                <span>**</span>
              }</label>
              <app-dropdown
                [(appModel)]="formData.location_set_id"
                [list]="selectedSets"
                [value]="'id'"
                [name]="'set_name'"
                [toCreate]="true"
                [(createValue)]="formData.location_set_name"
                [uppercase]="true"
                [required]="true"
              ></app-dropdown>
            </div>
            <div class="containerChecks">
              <div class="checkBoxCOnt">
                <input type="checkbox" name="added_scene" [(ngModel)]="formData.added_scene">
                <p class="checkbox">{{'Add scene' | translate}}</p>
              </div>
              <div class="checkBoxCOnt">
                <input type="checkbox" name="establishing_shoot" [(ngModel)]="formData.establishing_shoot">
                <p class="checkbox">{{'Establishing shoot' | translate}}</p>
              </div>
              <div class="checkBoxCOnt">
                <input type="checkbox" name="flashback" [(ngModel)]="formData.flashback">
                <p class="checkbox">{{'Flashback' | translate}}</p>
              </div>
              <div class="checkBoxCOnt">
                <input type="checkbox" name="manually_produced" [(ngModel)]="formData.manually_produced">
                <p class="checkbox">{{'Produced' | translate}}</p>
              </div>
            </div>
            <div class="L-12 M-12 S-12 columns">
              <label>{{'Description' | translate}}**</label>
              <textarea rows="5" name="description" [(ngModel)]="formData.description" placeholder="{{'Insert text' | translate}}" [required]="true"></textarea>
            </div>
            <div class="L-12 M-12 S-12 columns">
              <h2 class="AlignLeft">{{'Characters' | translate}}</h2>
              @for (cast of formData.characters; track cast; let i = $index) {
                <div class="form_with_button" >
                  <div class="form_container">
                    <div class="L-4 M-4 S-4 columns">
                      <label>{{'Character role' | translate}}**</label>
                      <app-dropdown
                        [(appModel)]="cast.character_role_id"
                        (appModelChange)="roleChange(i, cast)"
                        [list]="viewData.character_roles"
                        [value]="'id'"
                        [name]="'name'"
                        [toCreate]="true"
                        [(createValue)]="cast.character_role"
                        [backTranslate]="true"
                        [required]="true"
                      ></app-dropdown>
                    </div>
                    <div class="columns" [ngClass]="{'L-8 M-8 S-8': cast.character_role_id < 5 || cast.character_role_id == undefined, 'L-6 M-6 S-6': cast.character_role_id >= 5 || project.production_center_id == PRODUCTIONCOUNTRY.Brasil}">
                      <label>{{'Character' | translate}}**</label>
                      <app-dropdown
                        [(appModel)]="cast.character_id"
                        [list]="filteredCharacters[i]"
                        [value]="'id'"
                        [name]="'character_name'"
                        [toCreate]="true"
                        [required]="true"
                        [(createValue)]="cast.character_name"
                        (appModelChange)="selectedCharacter(i)"
                      ></app-dropdown>
                    </div>
                    @if (cast.use_quantity) {
                      <div class="L-2 M-2 S-2 columns">
                        <label>{{'Qty' | translate}}**</label>
                        <input class="centered" type="text" name="{{'cast_' + i + '_quantity' }}" [(ngModel)]="cast.quantity" placeholder="{{'Quantity' | translate}}" [pattern]="_gS.regex.number"  maxlength="4" required>
                      </div>
                    }
                    @if (project.production_center_id == PRODUCTIONCOUNTRY.Brasil) {
                      <div class="L-2 M-2 S-2 columns">
                        <label>{{'Change' | translate}}</label>
                        <input class="centered" type="text" name="{{'cast_' + i + '_wd_change' }}" [(ngModel)]="cast.wd_change" placeholder="{{'Change' | translate}}">
                      </div>
                      <div class="L-12 M-12 S-12 columns">
                        <label>{{'Comment change' | translate}}</label>
                        <input class="centered" type="text" name="{{'cast_' + i + '_wd_comment' }}" [(ngModel)]="cast.wd_comment" placeholder="{{'Comment' | translate}}">
                      </div>
                    }
                  </div>
                  <div class="form_button">
                    <span (click)="deleteCharacter(i)"></span>
                  </div>
                </div>
              }
              <a class="addContainer" (click)="addCharacter()">{{'Click to add new character' | translate }}</a>
            </div>
            <div class="L-12 M-12 S-12 columns">
              <h2 class="AlignLeft">{{'Elements' | translate}}</h2>
              @for (element of formData.elements; track element; let i = $index) {
                <div class="form_with_button" >
                  <div class="form_container">
                    <div class="L-4 M-4 S-4 columns">
                      <label>{{'Category' | translate}}**</label>
                      <app-dropdown
                        [(appModel)]="element.element_category_id"
                        (appModelChange)="elementChange(i)"
                        [list]="viewData.element_categories"
                        [value]="'id'"
                        [name]="'name'"
                        [backTranslate]="true"
                        [required]="true"
                        [toCreate]="true"
                        [(createValue)]="element.element_category"
                      ></app-dropdown>
                    </div>
                    <div class="L-8 M-8 S-8 columns">
                      <label>{{'Element' | translate}}**</label>
                      <app-dropdown
                        [(appModel)]="element.element_id"
                        [list]="filteredElements[i]"
                        [value]="'id'"
                        [name]="'element_name'"
                        [toCreate]="true"
                        [required]="true"
                        [(createValue)]="element.element_name"
                        (appModelChange)="selectedElements(i)"
                      ></app-dropdown>
                    </div>
                  </div>
                  <div class="form_button">
                    <span (click)="deleteElement(i)"></span>
                  </div>
                </div>
              }
              <a class="addContainer" (click)="addElement()">{{'Click to add new element' | translate }}</a>
            </div>
            <div class="L-12 M-12 S-12 columns">
              <h2 class="AlignLeft">{{'Events' | translate}}</h2>
              @for (event of formData.events; track event; let i = $index) {
                <div class="form_with_button" >
                  <div class="form_container">
                    <div class="L-4 M-4 S-4 columns">
                      <label>{{'Event type' | translate}}**</label>
                      <app-dropdown
                        [(appModel)]="event.event_type_id"
                        (appModelChange)="eventChange(i)"
                        [list]="viewData.event_types"
                        [value]="'id'"
                        [name]="'name'"
                        [backTranslate]="true"
                        [required]="true"
                      ></app-dropdown>
                    </div>
                    <div class="L-8 M-8 S-8 columns">
                      <label>{{'Name' | translate}}**</label>
                      <app-dropdown
                        [(appModel)]="event.event_id"
                        [list]="filteredEvents[i]"
                        [value]="'id'"
                        [name]="'event_name'"
                        [toCreate]="true"
                        [(createValue)]="event.event_name"
                        [required]="true"
                        (appModelChange)="selectedEvents(i)"
                      ></app-dropdown>
                      <!-- <input class="centered" type="text" name="{{'event_' + i + '_event_name'}}" [(ngModel)]="event.event_name" placeholder="{{'Insert number' | translate}}" [pattern]="_gS.regex.number" maxlength="3" required> -->
                    </div>
                  </div>
                  <div class="form_button">
                    <span (click)="deleteEvent(i)"></span>
                  </div>
                </div>
              }
              <a class="addContainer" (click)="addEvent()">{{'Click to add new event' | translate }}</a>
            </div>
            <div class="L-12 M-12 S-12 columns">
              <h2 class="AlignLeft">{{'Comments' | translate}}</h2>
              @for (comment of formData.comments; track comment; let i = $index) {
                <div class="form_with_button" >
                  <div class="form_container">
                    <textarea rows="5" name="{{'comment_' + i}}" [(ngModel)]="comment.comment" placeholder="{{'Insert text' | translate}}" ></textarea>
                  </div>
                  <div class="form_button">
                    <span (click)="deleteComment(i)"></span>
                  </div>
                </div>
              }
              <a class="addContainer" (click)="addComment()">{{'Click to add new comment' | translate}}</a>
            </div>
            <div class="L-12 M-12 S-12 columns TextCentered">
              <input name="sumbit" type="submit" value="{{'Save' | translate}}" [attr.disabled]="form.invalid || checkInvalidForm() ?'':null">
            </div>
            <div class="L-12 M-12 S-12 columns TextCentered">
              <a class="button cancel" (click)="close()">{{'Cancel' | translate}}</a>
            </div>
            <!-- <p *ngIf="form?.invalid" class="L-12 M-12 S-12 columns TextCentered">
            Form is invalid. Errors:
            <ng-container *ngFor="let control of getInvalidControls(form)">
              <span>{{ control.name }}: {{ getErrorMessages(control.control) }}</span><br>
            </ng-container>
          </p> -->
        </form>
      }
      @if (position == 'copy') {
        @if (!duplicate) {
          <h1>
            {{'Copy from scene' | translate}}
            <a (click)="changePosition('home')">{{'Cancel' | translate}}</a>
          </h1>
        }
        <h3>{{'System will copy characters and elements from scene selected' | translate}}</h3>
        <form #form="ngForm" (ngSubmit)="copyData()" novalidate>
          <div class="row">
            <div class="L-6 M-6 S-12 columns">
              <label>{{'Chapter' | translate}}**</label>
              <app-dropdown
                [(appModel)]="copyFormData.chapter_id"
                (appModelChange)="selectedChapter()"
                [list]="list_chapters"
                [value]="'id'"
                [name]="'number'"
              ></app-dropdown>
            </div>
            @if (copyFormData.chapter_id) {
              <div class="L-6 M-6 S-12 columns">
                <label>{{'Scene' | translate}}**</label>
                <app-dropdown
                  [(appModel)]="copyFormData.scene_id"
                  [list]="filtered_scenes"
                  [value]="'id'"
                  [name]="'scene_number'"
                ></app-dropdown>
              </div>
            }
          </div>
          <div class="L-12 M-12 S-12 columns TextCentered">
            <input name="sumbit" type="submit" value="{{'Copy' | translate}}" [attr.disabled]="!copyFormData.chapter_id || !copyFormData.scene_id ?'':null">
          </div>
          <div class="L-12 M-12 S-12 columns TextCentered">
            <a class="button cancel" (click)="changePosition('home')">{{'Cancel' | translate}}</a>
          </div>
        </form>
      }
    </div>
  }
</div>
